import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation, useParams} from "react-router-dom";
import {routeFunctions, routes} from "../../../../core/models/static/routes/app-routes";
import useAccessLevels from "../../../hooks/use-access-levels";
import VendorAccountInfoView from "./account-info";
import VendorNotesView from "./notes";
import VendorProductsView from "./products";

/**
 * Vendor mini-platform routes: account info, notes, products.
 * Purchases (orders/history) mount via common/purchases dual-scope shell.
 */
const VendorViews = () => {
    const history = useHistory();
    const location = useLocation();
    const params = useParams();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Bare vendor base redirects to account info.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.vendor.base, exact: true})) {
            const {base} = operatorAccessLevels.packages;
            if (base.viewVendorAccountInfo) {
                history.replace(routeFunctions.vendor.accountInfo(params.vendorId));
            } else if (base.viewVendorProducts) {
                history.replace(routeFunctions.vendor.products(params.vendorId));
            } else if (base.viewVendorNotes) {
                history.replace(routeFunctions.vendor.notes(params.vendorId));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages, params.vendorId]);

    return (
        <Switch>
            {
                operatorAccessLevels.packages.base.viewVendorAccountInfo &&
                <Route path={routes.vendor.accountInfo} exact>
                    <VendorAccountInfoView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.viewVendorProducts &&
                <Route path={routes.vendor.products} exact>
                    <VendorProductsView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.viewVendorNotes &&
                <Route path={routes.vendor.notes} exact>
                    <VendorNotesView/>
                </Route>
            }
            <Route path={routes.vendor.base} exact>
                <Redirect to={routeFunctions.vendor.accountInfo(params.vendorId)}/>
            </Route>
        </Switch>
    );
};

export default VendorViews;
